// extracted by mini-css-extract-plugin
export var legendIndicator = "_ce-1";
export var legendRight = "_ce-0";